import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { STATUS_STYLES } from "@/lib/constants";
import { jobTypeColor, textOn } from "@/lib/jobTypes";
import { useSettings } from "@/context/SettingsContext";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className, testId }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.Hold;
  return (
    <span data-testid={testId} className={cn("inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold", s.badge, className)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {status}
    </span>
  );
};

export const JobTypeChip = ({ name, className }) => {
  const { settings } = useSettings();
  if (!name) return <span className="text-slate-400">—</span>;
  const color = jobTypeColor(settings.job_types, name);
  return (
    <span className={cn("inline-block whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-semibold", className)} style={{ background: color, color: textOn(color) }} data-testid="job-type-chip">
      {name}
    </span>
  );
};

export const BackButton = ({ className }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/" || pathname === "/dashboard") return null;
  const go = () => navigate(-1);
  return <button type="button" onClick={go} data-testid="page-back-button" className={cn("mb-2 inline-flex items-center gap-1 text-sm text-slate-500 transition-colors hover:text-slate-900", className)}><ArrowLeft className="h-4 w-4" /> Back</button>;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <BackButton />
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#0E1E38] sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, action, children, className, id }) => (
  <section id={id} className={cn("rounded-xl border border-slate-200 bg-white", className)}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3.5">
        <h2 className="font-display text-base font-semibold text-[#0E1E38]">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);
